import { useEffect, useRef } from "react";

export const    checkIfIsValidEmail = (email:string | undefined) => {
    const regex = new RegExp(/^[\w\-.]+@([\w-]+\.)+[\w-]{2,4}$/g);
    if (email) return regex.test(email);
    else return false;
  };

export const deepCopy = (object :any) => {
  if(object)  return JSON.parse(JSON.stringify(object))
  return undefined;
}

export const checkIfValidDomain = (site: string | undefined) => {
  const regex = new RegExp(/(http:\/\/|https:\/\/)+[^\s]+[\w]\.[\w]+/g);
  if (site) {
    let isValid = regex.test(site);
    console.log(" is site valid ",isValid );
    return isValid;
  }
  else return false;
}

export const isValidCpf = (cpf: number | string) =>{
  if (cpf.toString().length >= 11) {

    let cpfArray = cpf.toString().split("").map(v=> parseInt(v));
    let invalidCpfRepeatChar =cpfArray[0];
    if(cpfArray.filter(pos => invalidCpfRepeatChar !== pos ).length === 0){
      return false;
    }
    let totalCpf = 0;
    for (var i = 0; i < 9; i++) {
      totalCpf = totalCpf + cpfArray[i] * (i + 1);
    }
    let r1 = totalCpf % 11;
    let totalCpf2 = 0;
    for (var x = 0; x < 10; x++) {
      totalCpf2 = totalCpf2 + cpfArray[x] * x;
    }
    let r2 = totalCpf2 % 11;
    r2 = r2 === 10 ? 0 : r2;
    r1 = r1 === 10 ? 0 : r1;
    if (r1 === cpfArray[9] && r2 === cpfArray[10]) {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
}

export const isValidCNPJ = (cnpj: number | string) =>{
  if(cnpj && cnpj.toString().length ===14) return true;
  return false;
}

export function useMount(f: () => void): void{
  const mountou = useRef(false);
  useEffect(( ) => {
    if(!mountou.current){
      mountou.current =true;
      f();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}
